import { render, staticRenderFns } from "./activityCourseMaterialRevamped.html?vue&type=template&id=e24aceb4&scoped=true&external"
import script from "./activityCourseMaterialRevamped.vue?vue&type=script&lang=js"
export * from "./activityCourseMaterialRevamped.vue?vue&type=script&lang=js"
import style0 from "./activityCourseMaterialRevamped.css?vue&type=style&index=0&id=e24aceb4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24aceb4",
  null
  
)

export default component.exports